<template>
  <div class="container">
    <div class="apply_tab">
      <img @click="handleBack" style="width: 24px; height: 24px" src="../assets/back.png" />
      <div>{{initialData.linkType == 1 ? '知识库' : 'banner详情'}}</div>
    </div>
    <div class="content">
      <div class="title">{{renderTitle()}}</div>
      <div>
        <div>
          <span class="content_create">{{dayjs(result.creatDate).format("YYYY-MM-DD")}}</span>
          <span class="content_create" style="margin-left:0.32rem">{{result.createName}}</span>
        </div>
        <img style="width: 8.4rem;height: 4.27rem;margin-top:0.53rem" :src="handleImg()" />
        <div class="content_box" v-html="handleContent()"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKnowDeatil, getBannerDetail } from '@/axios/services'
import { Toast } from 'vant';
import dayjs from 'dayjs';
import { mapState } from 'vuex'
export default {
  data() {
    return {
      id: '',
      result:{}
    }
  },
  computed: {
    ...mapState(['initialData'])
  },
  created() {
    this.id = this.initialData.id
    if(this.initialData.linkType == 1) {
      this.getKnowDeatil();
    }else {
      this.getBannerDetail()
    }
    
  },
  methods: {
    dayjs,
    getKnowDeatil() {
      getKnowDeatil(this.id).then(res => {
        if(res.data.code === 0) {
          this.result = res.data.data
        }else {
          Toast.fail(res.data.msg);
        }
      })
    },
    getBannerDetail() {
      getBannerDetail(this.id).then(res => {
        if(res.data.code === 0) {
          this.result = res.data.data
        }else {
          Toast.fail(res.data.msg);
        }
      })
    },
    handleContent() {
      if(this.initialData.linkType == 1) {
        let str = this.result.content;
        str = str.replace(/img/g, 'img style="width: 100%"')
        return str
      }else {
        let str = this.result.noticeContent;
        str = str.replace(/img/g, 'img style="width: 100%"')
        return str
      }
    },
    handleImg() {
      if(this.initialData.linkType == 1) {
        return this.result.imgUrl
      }else {
        return this.result.bannerUrl
      }
    },
    handleBack() {
      window.location.href = "jsToOc://back";
    },
    renderTitle() {
      if(this.initialData.linkType == 1) {
        return this.result.title
      }else {
        return this.result.noticeName
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 1.81rem;
  background: #f9f9f9;
  position: relative;
  padding-top: 1.71rem;
}
.apply_tab {
  width: 100%;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}
.apply_tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.content {
  width: 100%;
  padding: 0 0.8rem;
}
.title {
  width: 100%;
  /* height: 1.28rem; */
  font-size: 0.48rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 1.28rem;
  text-align: center;
}
.content_create {
  font-size: 0.32rem;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
}
.content_box {
  width: 100%;
  margin-top:0.27rem
}
.content_box p img {
  width: 100% !important;
}
</style>